import {
  FormFooter as BaseFormFooter,
  FormFooterSubmit,
  FormFooterCancel,
} from 'components/FormFooter';
import { useFormPrompt } from 'hooks';
import { useFormContext } from 'libs/form/useFormContext';

interface Props {
  submitLoading?: boolean;
}

export const FormFooter = ({ submitLoading }: Props) => {
  const { readOnly, dirty, resetForm } = useFormContext();

  const { confirmIsChanged } = useFormPrompt();

  const disableEditable = () => {
    confirmIsChanged(() => resetForm());
  };

  return (
    <BaseFormFooter visible={!readOnly}>
      <FormFooterCancel disabled={!dirty} onClick={disableEditable} />
      <FormFooterSubmit disabled={!dirty} loading={submitLoading} />
    </BaseFormFooter>
  );
};
